<template>
    <div id="results" class="page">
        <template v-if="isWinner">
          <!-- <div class="results-confetti-bg">
            <canvas id="resultsConfettiBgCanvas" ref="resultsConfettiBgCanvas"></canvas>
          </div> -->
          <div class="head-wrapper">
            <h2 class="head-copy in">You Won!</h2>
            <p class="sub-copy in">Fill out the following info and we'll mail you the prize!</p>
          </div>

          <div class="stage-wrapper">
            <div id="user-form">

              <Input
                v-model="userData.name.value"
                defaultText="Name"
                dataType="text"
                regex="^[a-zA-Z\s]*$"
                :onInputCB="(errLog) => { validateData('name', errLog) }"
              />

              <Input
                v-model="userData.email.value"
                defaultText="Email"
                dataType="email"
                :customFilter="validateEmail"
                :onInputCB="(errLog) => { validateData('email', errLog) }"

              />

              <Input
                v-model="userData.phone.value"
                defaultText="Phone Number"
                dataType="tel"
                :customFilter="validatePhone"
                :onInputCB="(err) => { validateData('phone', err) }"

              />
              <!-- old regex -->
              <!-- regex="^[0-9\-]{1,45}$" -->
              <!-- regex="(?=(?:-*\d){10}).{10,}" -->

              <Input
                v-model="userData.address.value"
                defaultText="Address"
                dataType="text"
                regex="^[a-zA-Z0-9\s\-\.\#\'\()]*$"
                :onInputCB="(err) => { validateData('address', err) }"

              />

              <Input
                v-model="userData.city.value"
                defaultText="City"
                dataType="text"
                regex="^[a-zA-Z0-9\s\-\.]*$"
                :onInputCB="(err) => { validateData('city', err) }"

              />

              <div class="grid">
                <Input
                  v-model="userData.province.value"
                  defaultText="Province"
                  dataType="select"
                  :selectOptions="provinces"
                  :onInputCB="(err) => { validateData('province', err) }"

                />

                <Input
                  v-model="userData.postalCode.value"
                  defaultText="Postal Code"
                  dataType="text"
                  regex="^([a-zA-Z0-9]{3}( ?)[a-zA-Z0-9]{3})$"
                  :onInputCB="(err) => { validateData('postalCode', err) }"

                />
                <!-- old regex -->
                <!-- regex="^[a-zA-Z0-9\s\-\.]*$" -->
              </div>

              <!-- <Input
                defaultText="Address"
                dataType="textarea"
              /> -->


            </div>

              <Button
                :isValid="validForm"
                label="Submit"
                :callback="storeData"
              />


          </div>

        </template>

        <template v-else>
          <div class="head-wrapper">
            <h2 class="head-copy in">Sorry! <span>You're not a winner today</span></h2>
          </div>

          <div class="stage-wrapper">
            <div class="egg-spacer"></div>
            <p class="sub-copy in">try again next time!</p>
          </div>

        </template>

    </div>
</template>

<script>
import Button from '../components/shared/Button'
import Input from '../components/shared/Input'

import { mapGetters, mapMutations } from 'vuex';

// import confetti from 'canvas-confetti';

export default {
  name: 'Results',
  components: {
    Button,
    Input,
  },

  data(){
    return {
      validForm: false,
      isWinner: this.$store.state.session.winner,
      submitting: false,

      userData: {
        name: {
          value: null,
          error: true
        },
        email: {
          value: null,
          error: true
        },
        phone: {
          value: null,
          error: true
        },
        address: {
          value: null,
          error: true
        },
        city: {
          value: null,
          error: true
        },
        province: {
          value: null,
          error: true
        },
        postalCode: {
          value: null,
          error: true
        },

        // selectedPrizeId: this.prizeId -> Not working???
        // selectedPrizeId: this.$store.state.session.prizeID
        //selectedPrizeId: 3
      },

      provinces: [
        {
          id: 'AB',
          value: 'Alberta',
        },
        {
          id: 'BC',
          value: 'British Columbia',
        },
        {
          id: 'MB',
          value: 'Manitoba'
        },
        {
          id: 'NB',
          value: 'New Brunswick'
        },
        {
          id: 'NL',
          value: 'Newfoundland and Labrador'
        },
        {
          id: 'NT',
          value: 'Northwest Territories'
        },
        {
          id: 'NS',
          value: 'Nova Scotia'
        },
        {
          id: 'NU',
          value: 'Nunavut'
        },
        {
          id: 'ON',
          value: 'Ontario'
        },
        {
          id: 'PE',
          value: 'Prince Edward Island'
        },
        {
          id: 'QC',
          value: 'Quebec'
        },
        {
          id: 'SK',
          value: 'Saskatchewan'
        },
        {
          id: 'YT',
          value: 'Yukon'
        },
      ],
    }
  },

  computed: {
    ...mapGetters([
      'prizeID',
      // 'isWinner',
    ])

  },

  updated(){
    //this.validateData();

  },

  mounted() {
    if( this.isWinner ) {
      // this.resultsConfetti = confetti.create(this.$refs.resultsConfettiBgCanvas, {resize:true});

      // this.resultsConfetti({
      //   particleCount: 100,
      //   spread: 70,
      //   startVelocity: 35,
      //   ticks: 300,
      //   colors: ['#fe5200', '#551e0a', '#fdef14'],
      //   origin: {
      //     y: 0.0,
      //   }
      // })

      this.fireConfetti();
    }
  },

  methods: {
    ...mapMutations([
      'storeUserData',
      'showConfetti',
    ]),

    validateData(inputKey, dataErr){
      // console.log('inputKey:', inputKey);
      // console.log(dataErr);
      let targetVal = this.userData[inputKey];
      targetVal.error = dataErr;

      this.validateUserData();

    },

    validateUserData(){
      let isValid = true;

      for ( let data in this.userData){
        let currData = this.userData[data];
        if (
              currData.value == null ||
              currData.error == true
            ){
              isValid = false;
            }
      }

      this.validForm = isValid;

    },

    validateEmail(userData){
      const _emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


      if (_emailRegex.test(userData)) {
          //valid
          console.log('valEmail')
          return false;

        } else {
          //invalid
          console.log('invalEmail')
          return true;

        }

    },

    validatePhone(value) {
      // console.log('validatePhone');

      const phoneRegex = /[0-9]/;
      const notDigitRegex = /[^(0-9\-)]/;
      let arr = value.split('');
      let count = 0;

      for( let i=0; i<arr.length; i++ ) {
        if( notDigitRegex.test(arr[i]) ) {
          return true;
        } else if( phoneRegex.test(arr[i]) ) {
          count++;
        }
      }

      // console.log('number of digits:', count);

      // return true;

      if( count >= 10 ) {
        return false;
      }

      return true;
    },

    storeData(){
      if( this.submitting ) {
        return;
      }

      console.log('storeData()');
      let payload = {};

      this.submitting = true;

      Object.keys(this.userData).forEach(key => {
        payload[key] = this.userData[key].value;
      });

      this.storeUserData(payload);
      this.$router.push('verify')
    },

    upateData(e){
      console.log('data: ', e);
    },

    fireConfetti() {
      console.log('Results fireConfetti()');
      this.showConfetti();
    },
  }

}
</script>


<style lang="scss">
@import "../styles/_variables.scss";
@import "../styles/_mixins.scss";

#results {

.head-wrapper {
  height: 27.5vh;

 &.hasMini {
      margin-top: 3.25em;

      &::after {
        content: '';

        width: 80px;
        height: 65px;
        position: absolute;
        left: 50%;
        @include crossBrowser(transform, translateX(-50%));

        margin-top: 0.5rem;
        background-image: url('../../public/assets/egg_beta_with_shadow.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        opacity: 1.0;

      }

    }

    &.out {
      opacity: 0.0;
      @include crossBrowser(transform, translateY(-10%));

    }


}

}

#floating-egg {
    position: absolute;
    width: 4rem;
    height: 6rem;
    top: 1.65em;
    overflow: hidden;
    right: .5rem;
}

#user-form{
  margin-bottom: 1.5rem;

    @media screen and (min-width: 600px) and (max-width: 768px) {
      margin-top: 1.25em;
    }

    @media only screen and (max-width: 600px) {
      margin-top: 1.25em;
    }

}

.grid {
  display: flex;
  margin: 0 .125em;

  & div {
    margin-right: .5em;

    &:last-of-type {
      margin-right: 0em;
    }
  }

}

.results-confetti-bg {
  position: absolute;
  top: 0;
  left: 50%;
  width: 110%;
  height: 100%;
  transform: translateX(-50%);

  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

</style>
